import { useMutationState } from "@tanstack/react-query";
import { THREAD_ROW_MUTATION_KEY } from "@/app/Threads/utils/invalidateThreadQueries";

/** The two spellings the thread mutations take their target under. */
type ThreadMutationVariables = { id?: string; thread_id?: string };

/**
 * The threads with a change in flight, so a row can show it is waiting. Read
 * from the mutations rather than passed down, so a close asked for from the
 * open thread's header shows on its row in the list too.
 */
export function usePendingThreadIds(): Set<string> {
  const pending = useMutationState({
    filters: { mutationKey: THREAD_ROW_MUTATION_KEY, status: "pending" },
    select: (mutation) => mutation.state.variables as ThreadMutationVariables,
  });

  return new Set(
    pending
      .map((variables) => variables?.id ?? variables?.thread_id)
      .filter((id) => id !== undefined),
  );
}
